import { AbstractControl } from '@angular/forms';

export function ValidateIfObject(control: AbstractControl) {
  if (typeof control.value === 'object') {
    return null;
  }
  return {invalidObject: true};
}
